import axiosInstance from '../../../helpers/backend_helper';

const deleteAmazonBookById = async (id) => {
  try {
    const response = await axiosInstance.delete(`/books/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting Amazon book with ID ${id}:`, error);
    throw error;
  }
};

export default deleteAmazonBookById;
